// extracted by mini-css-extract-plugin
export default {"heading":"DashboardTeacher_heading__FOwnD","input":"DashboardTeacher_input__3NxzI","loading":"DashboardTeacher_loading__YAiNZ","container":"DashboardTeacher_container__hntbq"};